import React from "react";



import { Form, InputNumber, SelectPicker } from "rsuite";

// className="custom-field-number-form-control"
export const FieldNumber = (props) => {
    return (
        <FieldInput
            accepter={InputNumber}
            className="custom-field-number-form-control"
            {...props}
        />
    );
};

export const FieldSelect = (props) => {
    return (
        <FieldInput
            accepter={SelectPicker}
            className="custom-field-select-form-control"
            {...props}
        />
    );
};

export const FieldInput = ({name, label, width, ...props}) => {
    return (<Form.Group style={{width}}>
        {label &&
            <div>
                <Form.ControlLabel>{label}</Form.ControlLabel>
            </div>
        }
        <Form.Control
            name={name}
            {...props}
        />
    </Form.Group>)
};